import { LinkOutlined  } from "@ant-design/icons";
import {
	CalendarOutlined,
	CommentOutlined,
	HomeOutlined,
	LoginOutlined,
	LogoutOutlined,
	MailOutlined,
	ProfileOutlined,
	UserOutlined,
} from "@ant-design/icons";
import React from "react";
import { ROLES } from "./permissions";

export const routes = {
	home: {
		key: "home",
		slug: "home",
		to: "/home",
		title: "Dashboard",
		icon: <HomeOutlined />,
		showInMenu: true,
		showHeader: true,
		showSearch: true,
		action: null,
		role: [ROLES.admin.role, ROLES.user.role],
	},

	profile: {
		key: "profile",
		slug: "profile",
		to: "/profile",
		title: "Perfil",
		icon: <UserOutlined />,
		showInMenu: false,
		showHeader: true,
		showSearch: true,
		action: null,
		role: [ROLES.admin.role, ROLES.user.role],
	},

	login: {
		key: "login",
		slug: "login",
		to: "/login",
		title: "LOGIN",
		icon: <LoginOutlined />,
		showInMenu: false,
		showHeader: false,
		showSearch: false,
		action: null,
		role: [ROLES.admin.role, ROLES.user.role],
	},

	consultations: {
		key: "consultations",
		slug: "consultations",
		to: "/consultations",
		title: "Consultas",
		icon: <ProfileOutlined />,
		showInMenu: true,
		showHeader: true,
		showSearch: true,
		action: null,
		role: [ROLES.admin.role],
	},
	appointments: {
		key: "appointments",
		slug: "appointments",
		to: "/appointments",
		title: "Citas",
		icon: <CalendarOutlined />,
		showInMenu: true,
		showHeader: true,
		showSearch: true,
		action: null,
		role: [ROLES.admin.role],
	},
	reviews: {
		key: "reviews",
		slug: "reviews",
		to: "/reviews",
		title: "Opiniones",
		icon: <CommentOutlined />,
		showInMenu: true,
		showHeader: true,
		showSearch: true,
		action: null,
		role: [ROLES.admin.role],
	},
	suggestions: {
		key: "suggestions",
		slug: "suggestions",
		to: "/suggestions",
		title: "Sugerencias",
		icon: <CommentOutlined />,
		showInMenu: true,
		showHeader: true,
		showSearch: true,
		action: null,
		role: [ROLES.admin.role],
	},
	contacts: {
		key: "contacts",
		slug: "contacts",
		to: "/contacts",
		title: "Contactos",
		icon: <MailOutlined />,
		showInMenu: true,
		showHeader: true,
		showSearch: true,
		action: null,
		role: [ROLES.admin.role],
	},

	users: {
		key: "users",
		slug: "users",
		to: "/users",
		title: "Usuarios",
		icon: <UserOutlined />,
		showInMenu: true,
		showHeader: true,
		showSearch: true,
		action: null,
		role: [ROLES.admin.role],
	},

referrals: {
    key: "referrals",
    slug: "referrals",
    to: "/referrals",
    title: "Remisións",
    icon: <LinkOutlined  />,
    showInMenu: true,
    showHeader: true,
    showSearch: true,
    action: null,
    role: [ROLES.admin.role],
},
	logout: {
		key: "logout",
		slug: "logout",
		to: "/logout",
		title: "Log out",
		icon: <LogoutOutlined />,
		showInMenu: false,
		showHeader: false,
		showSearch: false,
		action: null,
		role: [ROLES.admin.role, ROLES.user.role],
	},
};
